/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'forward-3c': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<metadata/><g transform="translate(-.997)" _fill="none" fill-rule="evenodd" _stroke="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><g transform="rotate(-180 12 10)" _stroke="#03272e"><polyline pid="0" transform="rotate(90 2 4)" points="6 2 2 6 -2 2"/><polyline pid="1" transform="rotate(90 7 4)" points="11 2 7 6 3 2"/><polyline pid="2" transform="rotate(90 12 4)" points="16 2 12 6 8 2"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/forward-3c.js